/*global window*/
import React, { useState } from "react";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  NavLink,
} from "shards-react";

import UserAvatar from "../../../../components/common/UserAvatar.jsx";
import { logOut } from "../../../../actions/auth.actions";
import { useDispatch, useSelector } from "react-redux";
import { keycloakConstants } from "../../../../constants";

const UserActions = () => {
  const [visible, setVisible] = useState(false);
  const currentStaff = useSelector((state) => state.currentUserReducers.user);
  const dispatch = useDispatch();
  const profileUrl = `${keycloakConstants.KEYCLOAK_ENDPOINT}/realms/${keycloakConstants.KEYCLOAK_REALM}/account/#/personal-info`;
  const logoutUrl = `${keycloakConstants.KEYCLOAK_ENDPOINT}/realms/${keycloakConstants.KEYCLOAK_REALM}/protocol/openid-connect/logout`;

  const toggleUserActions = () => {
    setVisible(!visible);
  };

  const handleLogout = (e) => {
    e.preventDefault();
    dispatch(logOut());
    window.location.href = logoutUrl;
  };

  const openProfile = (e) => {
    e.preventDefault();
    e.stopPropagation();
    // window.open(profileUrl);
    window.location.href = profileUrl;
  };

  return (
    <Dropdown open={visible} caret toggle={toggleUserActions}>
      <DropdownToggle caret tag={NavLink} className="text-nowrap px-3">
        <UserAvatar
          size={40}
          avatar_url={currentStaff.small_avatar_url}
          name={currentStaff.name || ""}
        />{" "}
        <span className="d-none d-md-inline-block">{currentStaff.name}</span>
      </DropdownToggle>
      <DropdownMenu>
        <a
          href={profileUrl}
          className="text-secondary dropdown-item"
          onClick={openProfile}
        >
          <i className="material-icons">&#xE7FD;</i> Profile
        </a>
        <DropdownItem divider />
        <a
          href="/logout"
          className="text-danger dropdown-item"
          onClick={handleLogout}
        >
          <i className="material-icons text-danger">&#xE879;</i> Logout
        </a>
      </DropdownMenu>
    </Dropdown>
  );
};

export default UserActions;
